export const inr = (n) =>
  n === null || n === undefined || n === "" ? "—" : "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const num = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("en-IN"));

export const fmtDate = (d) =>
  d ? new Date(d.length === 10 ? d + "T00:00:00" : d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const isoDate = (x) =>
  `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;

export const addDays = (d, n) => {
  const x = new Date(d + "T00:00:00");
  x.setDate(x.getDate() + n);
  return isoDate(x);
};

export function presetRange(preset, today) {
  const t = new Date(today + "T00:00:00");
  if (preset === "yesterday") return { from: addDays(today, -1), to: addDays(today, -1) };
  if (preset === "week") return { from: addDays(today, -((t.getDay() + 6) % 7)), to: today };
  if (preset === "month") return { from: today.slice(0, 8) + "01", to: today };
  return { from: today, to: today };
}

export const formatCell = (type, v) => {
  if (type === "money") return inr(v);
  if (type === "int") return num(v);
  if (type === "date") return fmtDate(v);
  if (type === "datetime") return fmtDT(v);
  return v ?? "—";
};
